import ImageLazy from '@Web/Src/Components/Image/Lazy/index.jsx';

function RoiCampaigns({ item, isHovered }) {
    const { img1, img1Low, img2, img2Low, alt } = item;
    return (
        <div className='medium:mx-auto medium:mt-20 group relative h-full w-full max-w-[400px] flex-1'>
            <ImageLazy
                className={`${isHovered ? 'translate-x-3 -rotate-[8deg]' : ''} ml-10 h-[500px] transform rounded-3xl duration-500 group-hover:translate-x-3 group-hover:-rotate-[8deg]`}
                src={img1}
                lowSrc={img1Low}
                alt={alt}
            />
            <ImageLazy
                className={`${isHovered ? 'rotate-[8deg]' : ''} absolute right-10 top-10 h-[500px] transform rounded-3xl shadow-[0px_241px_67px_rgba(0,0,0,0.00),0px_154px_62px_rgba(0,0,0,0.01),0px_87px_52px_rgba(0,0,0,0.05),0px_39px_39px_rgba(0,0,0,0.09),0px_10px_21px_rgba(0,0,0,0.10)] duration-500 group-hover:rotate-[8deg]`}
                src={img2}
                lowSrc={img2Low}
                alt={alt}
            />
        </div>
    );
}

export default RoiCampaigns;
